import React from "react";

import TourRunner from "../base/TourRunner";

import { jasperBulkEditTourConfiguration } from "./configuration";

const JasperBulkEditTour = () => {
  return <TourRunner descriptor={jasperBulkEditTourConfiguration} />;
};

export default JasperBulkEditTour;
